<template>
  <div class="diadin">

    <div class="title">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-input :placeholder="$t('menu.Title')" clearable v-model="formInline.title"></el-input>

        </el-form-item>
        <el-form-item>
          <el-select class="cinput" v-model="formInline.mcSeriesModel"  :placeholder="$t('menu.ScopeOfApplication')"
            clearable>
            <el-option v-if="inle == 'zh'" v-for="(item, index) in cheList" :key="index" :label="item.seriesModel"
              :value="item.id"></el-option>
            <el-option v-if="inle !== 'zh'" v-for="(item, index) in cheList" :key="index" :label="item.seriesModelEn"
              :value="item.id"></el-option>

          </el-select>
          <!-- <el-button type="primary" @click="search">{{ $t('menu.search') }}</el-button> -->
        </el-form-item>
         <el-form-item>
          <el-select class="cinput" v-model="formInline.category" :placeholder="$t('menu.fbwdwjlx') "
            clearable>
            <el-option  v-for="(item, index) in titleList" :key="index" :label="item.dictLabel"
              :value="item.dictValue"></el-option>
           

          </el-select>
          <el-button type="primary" @click="search">{{ $t('menu.search') }}</el-button>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" @click="upda()">{{ $t('menu.fbwdsc') }}</el-button>
      </div>
      <!-- <div class="bonntbot">
        <el-tabs v-model="action" @tab-click="searchType">
          <el-tab-pane v-for="(item, index) in titleList" :key="index" :label="item.dictLabel"
            :name="item.dictLabel"></el-tab-pane>


        </el-tabs>


      </div> -->
    
    </div>




    <el-table  empty-text=" " :data="mation" style="width: 100%" stripe border highlight-current-row>
      <el-table-column prop="fileName" :label="$t('menu.Title')">
        <template slot-scope="scope">
          <!-- <p>{{ inle == 'zh' ? scope.row.fileName : scope.row.fileNameEn }}.{{ formatTitle(scope.row) }}</p> -->
          {{ scope.row.fileName }}
        </template>
      </el-table-column>
       <el-table-column prop="category" :label="$t('menu.ApplicableModels')">
        <template slot-scope="scope">
          <p v-if="scope.row.category!==null">{{ formatChea(scope.row.category) }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="fileName" :label="$t('menu.ApplicableModels')">
        <template slot-scope="scope">
          <p v-if="scope.row.mcSeriesModel!==null">{{ formatChe(scope.row.mcSeriesModel) }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" :label="$t('menu.ReleaseTime')" width="280"> </el-table-column>
      <el-table-column prop="vin" width="300" :label="$t('menu.Operation')">
        <template slot="label">
          <div>{{ $t('menu.Operation') }}</div>
        </template>

        <template slot-scope="scope">
          <div class="btn">
             <el-button type="text" size="mini" @click="bianji(scope.row)">{{ $t('menu.Edit') }}</el-button>
               <el-button type="text" style="color: red;" size="mini" @click="deleup(scope.row)">{{ $t('menu.Delete') }}</el-button>
            <el-button type="text" size="mini" @click="downurl(scope.row, formatTitle(scope.row))">{{ $t('menu.Preview')
              }}</el-button>

            <el-button type="text" size="mini" >
              <a :href="ncodeUrlPath(scope.row.filePath)" :download="`${scope.row.fileName} ` + '.' + typ">{{ $t('menu.Download') }}</a>
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total,sizes, prev, pager, next" :total="totale">
      </el-pagination>

    </div>

    <div></div>
    <el-dialog :title="ylTitle" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">

      <div v-if="typ == 'txt'" v-html="txtUrl">

      </div>
      <video v-if="typ == 'mp4'" controls>
        <source :src="videoUrl" type="video/mp4">
      </video>

      <!-- <iframe v-if="typ == 'pdf'" :src="videoUrl"  width="100%" height="800px" /> -->
 <yl v-if="typ == 'pdf'" :url="videoUrl" :typ="'pdf'"></yl>
      <!-- <iframe v-if="typ == 'pdf'" :src="videoUrl"  width="100%" height="800px" /> -->
       <!-- <iframe v-if="typ == 'pdf'"  frameborder="0" :src="videoUrl"  width="100%" height="800px" /> -->
      <yl v-if="typ == 'xlsx'" :url="aurl" :typ="'xlsx'"></yl>
      <yl v-if="typ == 'docx'" :url="aurl" :typ="'docx'"></yl>
      <yl v-if="typ == 'excel'" :url="aurl" :typ="'excel'"></yl>
      <img v-if="typ == 'png' || typ == 'jpg' || typ == 'jepg'" :src="imgurl" alt="">
      <iframe v-if="typ !== 'png' && typ !== 'jpg' && typ !== 'jepg' && typ !== 'mp4' && typ !== 'txt' && typ !== 'pdf'&& typ !== 'xlsx'&& typ !== 'docx'&& typ !== 'excel'"
        :src='aurl' style="width: 100%; height: 70vh" frame />
     
    </el-dialog>
    <el-dialog
      :title="uptitlename"
      :visible.sync="dialogVisiblea"
      width="30%"
      :before-close="handleClose">
        <div>
        
          <el-form ref="formup" :rules="rules" :model="upform" >
            <el-form-item :label=" $t('menu.wenjianminame')" prop="fileName">
             <el-input v-model="upform.fileName"></el-input>
            </el-form-item>
            <el-form-item :label=" $t('menu.fbwdwjlx') " prop="category">
                <el-select class="cinput" v-model="upform.category" :placeholder="$t('menu.fbwdwjlx')"
            clearable>
            <el-option  v-for="(item, index) in titleList" :key="index" :label="item.dictLabel"
              :value="item.dictValue"></el-option>
          </el-select>
            </el-form-item>
            <el-form-item :label=" $t('menu.ApplicableModels') ">
            
             <el-select class="cinput" multiple v-model="upform.mcSeriesModel" :placeholder="$t('menu.ScopeOfApplication')"
            clearable>
            <el-option v-if="inle == 'zh'" v-for="(item, index) in cheList" :key="index" :label="item.seriesModel"
              :value="item.id+''"></el-option>
            <el-option v-if="inle !== 'zh'" v-for="(item, index) in cheList" :key="index" :label="item.seriesModelEn"
              :value="item.id+''"></el-option>

          </el-select>
            </el-form-item>
            <el-form-item :label=" $t('menu.wenjian') ">
             <!-- <el-input v-model="upform.filePath"></el-input> -->
             <el-upload
          
               class="upload-demo"
                action="#"
                :http-request="uploadFile"
               :on-preview="handlePreview"
               :on-remove="handleRemove"
               :before-remove="beforeRemove"
               multiple
               :limit="1"
               :on-exceed="handleExceed"
               :file-list="fileupList">
               <el-button    size="small" type="primary">{{ $t('menu.Uploadfiles') }}</el-button>
               <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
              </el-upload>
            </el-form-item>
          </el-form>  
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('menu.Cancel') }}</el-button>
        <el-button type="primary" @click="updatawendang()">{{ $t('menu.Confirm') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script type="text/javascript" src="https://cdn.jsdelivr.net/npm/js-base64@3.6.0/base64.min.js"></script>
<script>
import { documentLista, querytype, listMcSeriesModels,upload,updataDocument,putDocument,deleDocument } from "../../api/api";
import axios from "axios"
import yl from '../../components/yl' //发票
export default {
   components: {
    yl
   
  },
  data () {
    return {
      currentPage3: 1,
      dialogVisible: false,
      dialogVisiblea:false,
      uptitlename: this.$t('menu.fabuwendang'), 
      pagesize: 10,
      aurl: '',
      totale: 3,
      activeName: "first",
      mation: [], //列表
      fileupList:[],
      action: this.$t('menu.All'),
      titleList: [
        // {
        //   dictValue: '',
        //   dictLabel: this.$t('menu.All')
        // }
      ],
        rules: {
          fileName: [
            { required: true, message: '请输入名称', trigger: 'blur' },
           
          ],
          category: [
            { required: true, message: '请选择', trigger: 'change' }
          ],
        },
      upform:{
        fileName:'',
        category:'',
        mcSeriesModel:'',
        filePath:'',
        
      },
      formInline: {
        title: "",
        status: "",
        startTime: "",
        endTime: "",
        contact: "",
        category: "",
        type: "",
        mcSeriesModel: '',
      },
      inle: 'zh',
      ylTitle: '',
      a: false,
      b: false,
      cheList: [],
      txtUrl: '',
      typ: '',
      videoUrl: '',
      imgurl: ''
    };
  },
  created () {
    let a = sessionStorage.getItem('i18n')
    this.inle = a
    this.biao();
    this.getQuerytype()
    this.getListMcSeriesModels()

  },
  methods: {
     ncodeUrlPath(url) {
  // 找到最后一个 '/' 的位置
  const lastSlashIndex = url.lastIndexOf('/');

  // 如果没有找到 '/', 直接返回原字符串
  if (lastSlashIndex === -1) {
    return url;
  }

  // 提取最后一个 '/' 之前的部分（包括 '/'）
  const prefix = url.substring(0, lastSlashIndex + 1);

  // 提取最后一个 '/' 之后的部分（文件名）
  const fileName = url.substring(lastSlashIndex + 1);

  // 对文件名部分进行 encodeURIComponent 转码
  const encodedFileName = encodeURIComponent(fileName);

  // 拼接返回
  return prefix + encodedFileName;
},
    //删除
    deleup(e){
      let param = new URLSearchParams();
      deleDocument(param,e.id).then(res=>{
        if(res.data.code == '200'){
          this.$message.success('删除完成')
        this.biao()
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    //打开编辑
    bianji(e){
      console.log(e.mcSeriesModel);
      if( typeof e.mcSeriesModel === 'string'){
            e.mcSeriesModel=e.mcSeriesModel.split(',')
      }
  
      this.upform={...e}
      this.fileupList=[]
      let a ={
        name:e.fileName,
        url:e.filePath
      }
      this.fileupList.push(a)
      this.uptitlename=this.$t('menu.bianjiwendan')
    //  this.upform.mcSeriesModel =this.upform.mcSeriesModel.split(',')
      this.dialogVisiblea=true
      
    },
    //新增文档
    updatawendang(){
    
      if(this.upform.fileName==''){
        return false
      }
       if(this.upform.category==''){
        return false
      }
      //  if(this.upform.mcSeriesModel==''){
      //   return false
      // }
      
       if(this.fileupList.length<1){
        return false
      }
     
      if(this.uptitlename==this.$t('menu.fabuwendang')){
        console.log(this.fileupList);
        
      this.upform.filePath=this.fileupList[0].url
      // let formdata = new FormData()
      // formdata.append('fileName',this.upform.fileName)
      // formdata.append('category',this.upform.category)
      // formdata.append('mcSeriesModel',this.upform.mcSeriesModel)
      // formdata.append('filePath',this.upform.filePath)
       this.upform.mcSeriesModel =this.upform.mcSeriesModel.join(',')
      updataDocument(this.upform).then(res=>{
        if(res.data.code == '200'){
          this.$message.success('发布完成')
          this.dialogVisiblea=false
          this.upform={
              fileName:'',
              category:'',
              mcSeriesModel:'',
              filePath:'',
            }
            this.biao()
        } else {
          this.$message.error(res.data.message)
        }
      })
      }else{
         this.upform.filePath=this.fileupList[0].url
         this.upform.mcSeriesModel =this.upform.mcSeriesModel.join(',')
      putDocument(this.upform).then(res=>{
        if(res.data.code == '200'){
          this.$message.success('编辑完成')
          this.dialogVisiblea=false
          this.upform={
              fileName:'',
              category:'',
              mcSeriesModel:'',
              filePath:'',
            }
             this.biao()
        } else {
          this.$message.error(res.data.message)
        }
      })
      }
     
      
    },
     uploadFile(file){
      console.log(file);
      
      let formdata = new FormData()
      formdata.append('file',file.file)
      formdata.append('category',file.file.type)
      upload(formdata).then(res=>{
        if(res.data.code == '200'){
          this.$message.success('上传成功')
           let a ={
              name:file.file.name,
              url:res.data.data
          }
          this.fileupList.push(a)
        } else {
          this.$message.error('上传失败')
        }
      })
    },
     handleRemove(file, fileList) {
        console.log(1);
      },
      handlePreview(file) {
        console.log(2);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`).then( ()=> {
          this.fileupList=[]
          console.log(123,this.fileupList );
          
        })

      },
    formatTitle (row) {

      let str = row.filePath
      let b = ''
      if (row !== ''&&str!==null) {

        b = str.substring(str.lastIndexOf(".") + 1, str.length);
        // console.log(b)
      }
      return b
    },
    handleClose (done) {
      this.upform={
              fileName:'',
              category:'',
              mcSeriesModel:'',
              filePath:'',
            }
            this.dialogVisible=false
      this.dialogVisiblea=false
       this.biao()

    },
    formatChe (ids) {
       let arr = ''
      if( typeof ids === 'string'){
           arr = ids.split(',')
      }else{
        arr = ids
      }
     
      let str = []
      arr.forEach(item => {
        // console.log(item)
        this.cheList.forEach(i => {
          // console.log(i)
          if (item == i.id && this.inle == 'zh') {
            str.push(i.seriesModel)
          }
          if (item == i.id && this.inle !== 'zh') {
            str.push(i.seriesModelEn)
          }
        })
      })
      // console.log(str)
      return str.join(',')
    },
    formatChea (ids) {
      let arr = this.titleList
      let  b =''
      arr.forEach(e => {
        if(e.dictValue==ids){
          b=e.dictLabel
        }
      });
     
      
      return b
    },
      sxtitle(e){
      let a =''
       
      if(this.inle=='zh'){
        a=e.dictLabel
      }
    if(this.inle=='en'){
      if(e.dictLabelEn.indexOf(":") !== -1){
       
        let c =JSON.parse(e.dictLabelEn)
     
        a=c.en
      }else{
        a=e.dictLabelEn
      }
      

      }
      if(this.inle=='de'){
         if(e.dictLabelEn.indexOf(":") !== -1){
             let d =JSON.parse(e.dictLabelEn)
a=d.de
         } else{
        a=e.dictLabelEn
      } 
         
      
      }
      return a

    },
    getListMcSeriesModels () {
      listMcSeriesModels().then(r => {
        this.cheList = r.data.data
      })
    },
    getQuerytype () {
      const params = new URLSearchParams()
      querytype(
        params,
        'sys_document_category'
      ).then(r => {
        if (r.data.code == 200) {
          r.data.data.forEach(i => {
            if (this.inle !== 'zh') {
              i.dictLabel =this.sxtitle(i) 
            }
            this.titleList.push(i)

          })
        }
      })
    },
    searchType (tab, event) {
      this.action = tab.label
      // console.log(tab);

      this.formInline.category = this.titleList[tab.index].dictValue
      this.biao()
    },
    search () {
      this.biao()
    },
    async biao () {
      let param = new URLSearchParams();
      let category = this.formInline.category;
      let type = this.formInline.type;
      let startTime = this.formInline.startTime;
      let endTime = this.formInline.endTime;
      let status = this.formInline.status;
      let searchValue = this.formInline.title;

      const { data: res } = await documentLista(
        param,
        this.formInline.mcSeriesModel,
        category,
        type,
        startTime,
        endTime,
        status,
        searchValue,
        this.currentPage3,
        this.pagesize,
        ""
        
      );

      this.mation = res.rows.filter(item => item.status != 0);
      this.totale = res.total;
    },

    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
      this.pagesize=val
      this.biao()
    },
    handleCurrentChange (val) {
      this.currentPage3=val
      this.biao();
    },
    upda(){
      this.uptitlename=this.$t('menu.fabuwendang')
       this.upform={
              fileName:'',
              category:'',
              mcSeriesModel:'',
              filePath:'',
            }
            this.fileupList=[]
      this.dialogVisiblea=true
    },
    base64Encode(e){
  var rv;
  rv = encodeURIComponent(e);
  rv = unescape(rv);
  rv = window.btoa(rv);
  return rv;
},
    downurl (row, e) {
      this.txtUrl = ''
      this.videoUrl = ''
      this.typ = e
      console.log(e);

        let a =sessionStorage.getItem('i18n')
        if(a=='zh'){
          this.ylTitle = row.fileName
        }else{
          this.ylTitle = row.fileNameEn 
        }
   
      // this.aurl='https://view.officeapps.live.com/op/view.aspx?src=https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath
      // this.aurl = 'https://view.bendamoto.com/onlinePreview?url='+encodeURIComponent(this.base64Encode(row.filePath))
this.aurl =row.filePath


      if (e == 'txt') {
        // axios.get('https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath, { responseType: 'text' })
        axios.get( row.filePath, { responseType: 'text' })
          .then(response => {
            // 根据设置的编码进行处理，这里假定utf-8
            this.txtUrl = response.data;
          })

      }
      if (e == 'mp4') {
        // this.videoUrl = 'https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath
        this.videoUrl = row.filePath
      }
      if (e == 'pdf') {
        // this.videoUrl = 'https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath
        

// var url = row.filePath; //要预览文件的访问地址
// window.open('http://127.0.0.1:8012/onlinePreview?url='+encodeURIComponent(Base64.encode(previewUrl)));
        // this.videoUrl = 'https://view.bendamoto.com/onlinePreview?url='+encodeURIComponent(this.base64Encode(row.filePath))
        this.videoUrl = row.filePath
      }
      if (e == 'png' || e == 'jpg' || e == 'jepg') {
        // this.videoUrl = 'https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath
        this.imgurl = row.filePath
      }
      console.log(123, this.imgurl);
      this.dialogVisible = true
    },
    downLoad (row) {
      console.log(row)
      // const fileURL = 'https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath; // 替换为你的文件URL
      const fileURL =  row.filePath; // 替换为你的文件URL
      // console.log(fileURL)
      // const link = document.createElement('a');
      // // 这里是将链接地址url转成blob地址，
      // fetch(fileURL).then(res => res.blob()).then(blob => {
      //   link.href = URL.createObjectURL(blob)
      //   // 下载文件的名称及文件类型后缀
      //   link.download = `${row.fileName} ` + '.' + this.typ;
      //   document.body.appendChild(link)
      //   link.click()
      //   //在资源下载完成后 清除 占用的缓存资源
      //   window.URL.revokeObjectURL(link.href);
      //   document.body.removeChild(link);
      // });

      const src = `${fileURL}?t=${new Date().getTime()}`
      fetch(src).then(res => {
        res.blob().then(myBlob => {
          const href = URL.createObjectURL(myBlob)
          const a = document.createElement('a')
          a.href = href
          a.download = `${row.fileName} ` + '.' + this.typ;
          a.click()
          a.remove()
        })
      })
    

    }
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.cinput {
  width: 300px;
  margin-right: 10px;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bonntbot {
  display: flex;
  justify-content: space-between;
  align-items: center;

}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

/deep/.el-table {
  min-height: 750px !important;
}

/deep/.el-table__body td {
  padding: 20px !important;
  padding-left: 0 !important;
  text-align: left;
}

/deep/.el-table th.is-leaf {
  text-align: left;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}

/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.btn {
  display: flex;
  justify-content: space-evenly;
  color: #31aff2;
}

/deep/.el-dialog__body {
  overflow: auto;
}

.title {
  padding-bottom: 10px;


  .status {
    display: flex;
    margin-top: 20px;

    div {
      margin-right: 25px;
      cursor: pointer;
    }
  }
}
a{text-decoration:none;color: #409EFF;}
 
a:hover{text-decoration:underline}
</style>